var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",attrs:{"id":"map"}}),_c('div',{staticClass:"my-5"},[_c('div',{staticClass:"section-description"},[_vm._v(_vm._s(_vm.event.address.name))]),_c('div',{staticClass:"section-description"},[_vm._v(_vm._s(_vm._f("address")(_vm.event.address)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }